
import { Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Helper function to create routes with and without language prefix
export const createRouteWithLang = (path: string, element: JSX.Element) => [
  <Route key={path} path={path} element={element} />,
  <Route key={`lang-${path}`} path={`/:lang${path}`} element={element} />
];

// Helper function to wrap lazy components with Suspense and skeleton
export const withSuspense = (LazyComponent: React.LazyExoticComponent<any>, SkeletonComponent: React.ComponentType) => (
  <Suspense fallback={<SkeletonComponent />}>
    <LazyComponent />
  </Suspense>
);
